import { IsolatesAntibioticsInterpretationsList } from "./IsolatesAntibioticsInterpretationsList";

export const isolates_antibiotics_interpretations = {
  list: IsolatesAntibioticsInterpretationsList,
};
